import { MatTableDataSource } from "@angular/material";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";

interface PontoDeAcesso {
  nodeId: number;
  idPontoDeAcesso: number;
  namePontoDeAcesso: string;
}

@Component({
  selector: "app-tabelaMatriz",
  templateUrl: "./tabelaMatriz.component.html",
  styleUrls: ["./tabelaMatriz.component.scss"],
})
export class TabelaMatrizComponent implements OnInit {
  public clientId;
  public tabelaMatriza: any;
  public pontosDeAcessoSelecionados: any[] = [];
  displayedColumns = ["title", "name", "pa1", "pa2", "pa3", "pa4", "pa5"];
  dataSource = new MatTableDataSource();
  disabledAspect: boolean = true;

  constructor(
    private configPastaService: ConfigurarPastaServiceService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe(
      (params) => (this.clientId = params["clientId"])
    );
  }

  ngOnInit() {
    this.buscarTabelaMatriz(this.clientId);
  }

  buscarTabelaMatriz(clienteId: number) {
    this.configPastaService.buscarTabelaMatriz(clienteId).subscribe(
      (data) => {
        this.dataSource = new MatTableDataSource(data);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  disabledAspectFunction() {
    if (this.pontosDeAcessoSelecionados.length > 0) {
      this.disabledAspect = false;
    } else {
      this.disabledAspect = true;
    }
  }

  checkIndividual1(event, element) {
    let dadoFiltrado: PontoDeAcesso = {
      nodeId: element.nodeId,
      idPontoDeAcesso: element.idPontoAcesso1,
      namePontoDeAcesso: element.namePontoAcesso1,
    };
    if (!event) {
      const filtro = (dadoFiltrado: any) => (dadoFiltrado.idPontoDeAcesso === element.idPontoAcesso1) && (dadoFiltrado.nodeId === element.nodeId);
      const elementoFiltrado = this.pontosDeAcessoSelecionados.find(filtro);
      const indexof = this.pontosDeAcessoSelecionados.indexOf(elementoFiltrado);
      this.pontosDeAcessoSelecionados.splice(
        indexof,
        1
      );
    } else {
      this.pontosDeAcessoSelecionados.push(dadoFiltrado);
    }

    this.disabledAspectFunction();
  }

  checkIndividual2(event, element) {
    let dadoFiltrado: PontoDeAcesso = {
      nodeId: element.nodeId,
      idPontoDeAcesso: element.idPontoAcesso2,
      namePontoDeAcesso: element.namePontoAcesso2,
    };
    if (!event) {
      const filtro = (dadoFiltrado: any) => (dadoFiltrado.idPontoDeAcesso === element.idPontoAcesso2) && (dadoFiltrado.nodeId === element.nodeId);
      const elementoFiltrado = this.pontosDeAcessoSelecionados.find(filtro);
      const indexof = this.pontosDeAcessoSelecionados.indexOf(elementoFiltrado);
      this.pontosDeAcessoSelecionados.splice(
        indexof,
        1
      );
    } else {
      this.pontosDeAcessoSelecionados.push(dadoFiltrado);
    }

    this.disabledAspectFunction();
  }

  checkIndividual3(event, element) {
    let dadoFiltrado: PontoDeAcesso = {
      nodeId: element.nodeId,
      idPontoDeAcesso: element.idPontoAcesso3,
      namePontoDeAcesso: element.namePontoAcesso3,
    };
    if (!event) {
      const filtro = (dadoFiltrado: any) => (dadoFiltrado.idPontoDeAcesso === element.idPontoAcesso3) && (dadoFiltrado.nodeId === element.nodeId);
      const elementoFiltrado = this.pontosDeAcessoSelecionados.find(filtro);
      const indexof = this.pontosDeAcessoSelecionados.indexOf(elementoFiltrado);
      this.pontosDeAcessoSelecionados.splice(
        indexof,
        1
      );
    } else {
      this.pontosDeAcessoSelecionados.push(dadoFiltrado);
    }

    this.disabledAspectFunction();
  }

  checkIndividual4(event, element) {
    let dadoFiltrado: PontoDeAcesso = {
      nodeId: element.nodeId,
      idPontoDeAcesso: element.idPontoAcesso4,
      namePontoDeAcesso: element.namePontoAcesso4,
    };
    if (!event) {
      const filtro = (dadoFiltrado: any) => (dadoFiltrado.idPontoDeAcesso === element.idPontoAcesso4) && (dadoFiltrado.nodeId === element.nodeId);
      const elementoFiltrado = this.pontosDeAcessoSelecionados.find(filtro);
      const indexof = this.pontosDeAcessoSelecionados.indexOf(elementoFiltrado);
      this.pontosDeAcessoSelecionados.splice(
        indexof,
        1
      );
    } else {
      this.pontosDeAcessoSelecionados.push(dadoFiltrado);
    }

    this.disabledAspectFunction();
  }

  checkIndividual5(event, element) {
    let dadoFiltrado: PontoDeAcesso = {
      nodeId: element.nodeId,
      idPontoDeAcesso: element.idPontoAcesso5,
      namePontoDeAcesso: element.namePontoAcesso5,
    };
    if (!event) {
      const filtro = (dadoFiltrado: any) => (dadoFiltrado.idPontoDeAcesso === element.idPontoAcesso5) && (dadoFiltrado.nodeId === element.nodeId);
      const elementoFiltrado = this.pontosDeAcessoSelecionados.find(filtro);
      const indexof = this.pontosDeAcessoSelecionados.indexOf(elementoFiltrado);
      this.pontosDeAcessoSelecionados.splice(
        indexof,
        1
      );
    } else {
      this.pontosDeAcessoSelecionados.push(dadoFiltrado);
    }

    this.disabledAspectFunction();
  }

  checkAllPA1(event) {
    let dadosFiltradosPA1: PontoDeAcesso[] = this.dataSource.filteredData
      .filter((el: any) => el.idPontoAcesso1 != null)
      .map((el: any) => {
        if (el.idPontoAcesso1 != null) {
          let pontoDeAcesso1: PontoDeAcesso = {
            nodeId: el.nodeId,
            idPontoDeAcesso: el.idPontoAcesso1,
            namePontoDeAcesso: el.namePontoAcesso1,
          };
          return pontoDeAcesso1;
        }
      });

    if (event) {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected1"] = true;
      }
      this.pontosDeAcessoSelecionados.push(...dadosFiltradosPA1);
    } else {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected1"] = false;
        let index = this.pontosDeAcessoSelecionados.findIndex(
          (elem) =>
            elem.idPontoDeAcesso ===
            this.dataSource.filteredData[i]["idPontoAcesso1"]
        );
        if (index !== -1) {
          this.pontosDeAcessoSelecionados.splice(index, 1);
        }
      }
    }

    // console.log(this.dataSource.filteredData);

    // console.log(dadosFiltradosPA1);

    // console.log(this.pontosDeAcessoSelecionados);

    this.disabledAspectFunction();
  }

  checkAllPA2(event) {
    let dadosFiltradosPA2: PontoDeAcesso[] = this.dataSource.filteredData
      .filter((el: any) => el.idPontoAcesso2 != null)
      .map((el: any) => {
        let pontoDeAcesso2: PontoDeAcesso = {
          nodeId: el.nodeId,
          idPontoDeAcesso: el.idPontoAcesso2,
          namePontoDeAcesso: el.namePontoAcesso2,
        };
        return pontoDeAcesso2;
      });

    if (event) {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected2"] = true;
      }
      this.pontosDeAcessoSelecionados.push(...dadosFiltradosPA2);
    } else {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected2"] = false;
        let index = this.pontosDeAcessoSelecionados.findIndex(
          (elem) =>
            elem.idPontoDeAcesso ===
            this.dataSource.filteredData[i]["idPontoAcesso2"]
        );
        if (index !== -1) {
          this.pontosDeAcessoSelecionados.splice(index, 1);
        }
      }
    }


    this.disabledAspectFunction();
  }

  checkAllPA3(event) {
    let dadosFiltradosPA3: PontoDeAcesso[] = this.dataSource.filteredData
      .filter((el: any) => el.idPontoAcesso3 != null)
      .map((el: any) => {
        let pontoDeAcesso3: PontoDeAcesso = {
          nodeId: el.nodeId,
          idPontoDeAcesso: el.idPontoAcesso3,
          namePontoDeAcesso: el.namePontoAcesso3,
        };
        return pontoDeAcesso3;
      });

    if (event) {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected3"] = true;
      }
      this.pontosDeAcessoSelecionados.push(...dadosFiltradosPA3);
    } else {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected3"] = false;
        let index = this.pontosDeAcessoSelecionados.findIndex(
          (elem) =>
            elem.idPontoDeAcesso ===
            this.dataSource.filteredData[i]["idPontoAcesso3"]
        );
        if (index !== -1) {
          this.pontosDeAcessoSelecionados.splice(index, 1);
        }
      }
    }

    this.disabledAspectFunction();
  }

  checkAllPA4(event) {
    let dadosFiltradosPA4: PontoDeAcesso[] = this.dataSource.filteredData
      .filter((el: any) => el.idPontoAcesso4 != null)
      .map((el: any) => {
        let pontoDeAcesso4: PontoDeAcesso = {
          nodeId: el.nodeId,
          idPontoDeAcesso: el.idPontoAcesso4,
          namePontoDeAcesso: el.namePontoAcesso4,
        };
        return pontoDeAcesso4;
      });

    if (event) {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected4"] = true;
      }
      this.pontosDeAcessoSelecionados.push(...dadosFiltradosPA4);
    } else {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected4"] = false;
        let index = this.pontosDeAcessoSelecionados.findIndex(
          (elem) =>
            elem.idPontoDeAcesso ===
            this.dataSource.filteredData[i]["idPontoAcesso4"]
        );
        if (index !== -1) {
          this.pontosDeAcessoSelecionados.splice(index, 1);
        }
      }
    }

    this.disabledAspectFunction();
  }

  checkAllPA5(event) {
    let dadosFiltradosPA5: PontoDeAcesso[] = this.dataSource.filteredData
      .filter((el: any) => el.idPontoAcesso5 != null)
      .map((el: any) => {
        let pontoDeAcesso5: PontoDeAcesso = {
          nodeId: el.nodeId,
          idPontoDeAcesso: el.idPontoAcesso5,
          namePontoDeAcesso: el.namePontoAcesso5,
        };
        return pontoDeAcesso5;
      });
    if (event) {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected5"] = true;
      }
      this.pontosDeAcessoSelecionados.push(...dadosFiltradosPA5);
    } else {
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        this.dataSource.filteredData[i]["isSelected5"] = false;
        let index = this.pontosDeAcessoSelecionados.findIndex(
          (elem) =>
            elem.idPontoDeAcesso ===
              this.dataSource.filteredData[i]["idPontoAcesso5"] &&
            elem.nodeId === this.dataSource.filteredData[i]["nodeId"]
        );
        if (index !== -1) {
          this.pontosDeAcessoSelecionados.splice(index, 1);
        }
      }
    }

    this.disabledAspectFunction();
  }

  criarAspecto() {
    this.configPastaService.setDataPontoDeAcesso(this.pontosDeAcessoSelecionados);
    this.router.navigate(["/aspecto-propriedade/", this.clientId]);
  }

  vincularAspecto() {
    this.configPastaService.setDataPontoDeAcessoVinculo(this.pontosDeAcessoSelecionados);
    this.router.navigate(["/vincular-aspecto-propriedade/", this.clientId]);
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/tabelaMatriz/tabelaMatriz.component.ts